import { QueryClient } from '@tanstack/react-query';
import Pubnub from 'pubnub';

import { studentJoinCacheUpdater } from './cacheUpdaters/studentJoinCacheUpdater';
import { studentLeaveCacheUpdater } from './cacheUpdaters/studentLeaveCacheUpdater';
import { studentPresenceIntervalCacheUpdater } from './cacheUpdaters/studentPresenceIntervalCacheUpdater';

type JoinEventType = 'join' | 'leave' | 'state-change' | 'timeout' | 'interval';

export const handlePresenceEvent = ({
  queryClient,
  event,
  isRosteredRoom,
  activityInstanceId,
}: {
  queryClient: QueryClient;
  event: Pubnub.PresenceEvent;
  isRosteredRoom: boolean;
  activityInstanceId: number;
}) => {
  switch (event.action as JoinEventType) {
    case 'join':
      studentJoinCacheUpdater({
        queryClient: queryClient,
        activityInstanceId: activityInstanceId,
        isRosteredRoom: isRosteredRoom,
        uuid: event.uuid,
      });
      break;
    case 'leave':
    case 'timeout':
      studentLeaveCacheUpdater({
        queryClient: queryClient,
        activityInstanceId: activityInstanceId,
        uuid: event.uuid,
      });
      break;
    case 'interval':
      studentPresenceIntervalCacheUpdater({
        queryClient: queryClient,
        activityInstanceId: activityInstanceId,
        uuidsJoined: event['join'],
        uuidsLeft: event['leave'],
        uuidsTimedOut: event['timeout'],
      });
      break;
    default:
      console.error('Unknown presence event', event.action);
      break;
  }
};
